import { LANGUAGES } from '@/utils/constants'

const { PORTUGUESE, ENGLISH, SPANISH } = LANGUAGES

export const NO = 'no'
export const YES = 'yes'
export const WARNING = 'warning'
export const PAUSE_THIS_FIELD = 'pause this field'
export const CONFIRMATION_TO_PROCEED = 'confirmation to proceed'

export default {
  [PORTUGUESE]: {
    [NO]: 'Não',
    [YES]: 'Sim',
    [WARNING]: 'Aviso',
    [PAUSE_THIS_FIELD]: 'Tem certeza de que deseja pausar este campo agora?',
    [CONFIRMATION_TO_PROCEED]: 'Confirmo que li o aviso e quero continuar.',
  },

  [ENGLISH]: {
    [NO]: 'No',
    [YES]: 'Yes',
    [WARNING]: 'Warning',
    [PAUSE_THIS_FIELD]: 'Are you sure you want to pause this field now?',
    [CONFIRMATION_TO_PROCEED]: 'I confirm I have read the warning and I want to proceed.',
  },

  [SPANISH]: {
    [NO]: 'No',
    [YES]: 'Sí',
    [WARNING]: 'Advertencia',
    [PAUSE_THIS_FIELD]: '¿Estás seguro de que quieres pausar este campo ahora?',
    [CONFIRMATION_TO_PROCEED]: 'Confirmo que he leído la advertencia y quiero continuar.',
  },
}
